import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../shared/layout/DashboardLayout';
import Otros from './components/OtrosViewer';

export default function MainValoracionFuncional() {
  const { idTipo, paciente } = useParams();

  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Otros idTipo={idTipo} paciente={paciente} />
      </Container>
    </DashboardLayout>
  );
}

export { default as MainCuestionarioTesisTorres } from './tesisTorres/MainCuestionarioTesisTorres';
